import Vue from 'vue'
import Router from 'vue-router'
import TodoListView from '@/components/TodoList/TodoListView'
import Hello from '@/components/Hello'
import CarsView from '@/components/Cars/CarsView'
import Login from '@/components/Login/Login'
import UsersView from '@/components/Users/UsersView'
import UserSingle from '@/components/Users/UserSingle'
import ManagePropertiesView from '@/components/Properties/ManagePropertiesView'

import ManageProperty from '@/components/Properties/ManageProperty'
import DatFastView from '@/components/Dat/DatFastView'

import CitiesView from '@/views/Cities/CitiesView'
import CitySingle from '@/views/Cities/CitySingle'


Vue.use(Router)

export default new Router({
  //mode: 'history',
  base: process.env.BASE_URL,

  routes: [


	{
      path: '/',
      name: 'Dashboard',
      component: CarsView,
    } ,	  
	{
      path: '/cars',
      name: 'Cars',
      component: CarsView,
    } ,	  
	{
		path: '/login',
		name: 'Login',
		component: Login,
	},
	{
      path: '/todo',
      name: 'TodoListView',
      component: TodoListView
    },
	{
      path: '/hello',
      name: 'Hello',
      component: Hello
    },
    
	{
      path: '/users',
      name: 'Users',
      component: UsersView,
	} ,	
      
		{
		      path: '/users/:userid',
		      name: 'UserSingle',
		      component: UserSingle,
		      props: true,
	    } ,	
    
	{
      path: '/manageproperties',
      name: 'ManageProperties',
      component: ManagePropertiesView,
	} ,	    

		{
	      path: '/manageproperties/:propid',
	      name: 'ManageProperty',
	      component: ManageProperty,
	      props: true,
	      history: true
	      
		} ,

		{
      path: '/datfastrequest',
      name: 'DatFast',
      component: DatFastView,
      props: true,
      history: true
    } ,

		{
      path: '/cities',
      name: 'Cities',
      component: CitiesView,
      props: false,
      history: true
    },
		{
		      path: '/cities/:cityid',
		      name: 'CitySingle',
		      component: CitySingle,
		      props: true,
	    },


    {
	    path: '*',
	    name: '404',
	    component: Login
    }
        
  ],
  

  
})
